import React from 'react'
import clsx from 'clsx'

import BaseModal from '../../molecules/ChatModals/BaseModal'
import PermissionsDebug from '../../molecules/PermissionsDebug'

import useStyles from './styles'

const TABS = {
  Permissions: PermissionsDebug,
  Unused: () => <div>Nothing here yet</div>
}

const DebugMenu = ({ onClose }) => {
  const [selected, setSelected] = React.useState(Object.keys(TABS)[0])
  const [count, setCount] = React.useState(0)

  const classes = useStyles()

  const Component = React.useMemo(() => TABS[selected], [selected])

  React.useEffect(() => {
    if (count === 2) {
      throw new Error('Not a bug, testing 2')
    }
  }, [count])

  return (
    <BaseModal
      open
      onClose={onClose}
      title='DEBUG MENU'
      PaperProps={{
        style: {
          minWidth: '70%',
          minHeight: '70%'
        }
      }}
    >
      <div className={classes.tabs}>
        {Object.keys(TABS).map(key => (
          <div
            key={key}
            onClick={() => setSelected(key)}
            className={clsx(
              classes.tab,
              key === selected && classes.tabSelected
            )}
          >
            {key}
          </div>
        ))}
      </div>

      <Component />

      <div
        onClick={() => {
          setCount(old => old + 1)
        }}
      >
        THROW ERROR {count}
      </div>
    </BaseModal>
  )
}

export default DebugMenu
